<template>
  <div class="about-page">
    <div class="about-image">
      <img
        :src="require(`../assets/austin_bass.jpg`)"
        alt="austin playing bass"
      />
      <h1>Music</h1>
      <div class="about-body">
        Hi, I'm Austin
        <br />
        <br />
        I'm a bass player in NYC, performing with various jazz and contemporary
        ensembles around the city
        <br />
        <br />
        Check out my music on
        <a
          href="https://open.spotify.com/artist/0qjN0qrKF4buPtDZi1Vopx"
          target="_blank"
          >Spotify</a
        >
        and follow me on
        <a href="https://www.instagram.com/bassclef.austin/" target="_blank"
          >Instagram</a
        >. For information on booking reach out to me at
        <a href="mailto:mudsweatgears@gmail.com">mudsweatgears@gmail.com</a>.
      </div>
      <div class="spotify-embed">
        <br />
        <iframe
          data-testid="embed-iframe"
          style="border-radius: 12px"
          src="https://open.spotify.com/embed/artist/0qjN0qrKF4buPtDZi1Vopx?utm_source=generator"
          width="40%"
          height="152"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Music",
};
</script>
